export default {
  methods: {
    goTo(url, params = {}) {
      this.$router.push({ name: url, params })
    }
  }
};
